var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.value,
      options: _vm.jobTitles,
      customMultiStyleParent: _vm.getcontainerStyle,
      loading: _vm.$apollo.queries.jobTitles.loading,
      placeholder: _vm.placeholder,
      single: true,
    },
    on: {
      search: (v) => (_vm.jobTitleSearchString = v),
      input: _vm.handleInput,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }